import * as types from './nftActionTypes';

export const getNftsActionRequest = (payload) => ({
  type: types.GET_NFTS_REQUEST,
  payload,
});

export const getNftsActionData = (payload) => ({
  type: types.GET_NFTS_DATA,
  payload,
});

export const getNftsActionError = (payload) => ({
  type: types.GET_NFTS_ERROR,
  payload,
});

export const createNftActionRequest = (payload) => ({
  type: types.CREATE_NFT_REQUEST,
  payload,
});

export const createNftActionData = (payload) => ({
  type: types.CREATE_NFT_DATA,
  payload,
});

export const createNftActionError = (payload) => ({
  type: types.CREATE_NFT_ERROR,
  payload,
});

export const updateNftActionRequest = (payload) => ({
  type: types.UPDATE_NFT_REQUEST,
  payload,
});

export const updateNftActionData = (payload) => ({
  type: types.UPDATE_NFT_DATA,
  payload,
});

export const updateNftActionError = (payload) => ({
  type: types.UPDATE_NFT_ERROR,
  payload,
});

export const deleteNftActionRequest = (payload) => ({
  type: types.DELETE_NFT_REQUEST,
  payload,
});

export const deleteNftActionData = (payload) => ({
  type: types.DELETE_NFT_DATA,
  payload,
});

export const deleteNftActionError = (payload) => ({
  type: types.DELETE_NFT_ERROR,
  payload,
});

export const updateQuickFilterAction = (payload) => ({
  type: types.UPDATE_QUICK_FILTER,
  payload,
});

export const filterNftsAction = (payload) => ({
  type: types.FILTER_NFTS,
  payload,
});

export const setNftsSortDataAction = (payload) => ({
  type: types.SET_NFTS_SORT_DATA,
  payload,
});

export const sortNftsAction = (payload) => ({
  type: types.SORT_NFTS,
  payload,
});
